import React, { useState, useEffect } from 'react'

import { useTranslation } from 'react-i18next'

// MUI Imports
import { Box } from '@mui/material'

// Component Imports
import CustomAutocomplete from '../atoms/CustomAutocomplete'
import CustomTextField from '../atoms/CustomTextField'

const getFromArray = (tableData) => {
  const initialFromArray = []
  const fromArr = tableData.reduce((acc, cur) => {
    return acc.includes(cur.fromAddress) ? acc : [...acc, cur.fromAddress]
  }, initialFromArray)

  return fromArr
}

const InboxTableFilters = ({ setData, tableData }) => {
  const { t } = useTranslation()

  const [fromArray, setFromArray] = useState([])
  const [selectedFrom, setSelectedFrom] = useState('')

  useEffect(() => {
    setFromArray(getFromArray(tableData))
  }, [tableData])

  useEffect(() => {
    const filteredData = tableData?.filter(row => {
      if (selectedFrom && row.fromAddress !== selectedFrom) return false

      return true
    })

    setData(filteredData)
  }, [selectedFrom, tableData, setData])

  return (
    <>
      <CustomAutocomplete
        sx={{ width: { xs: '100%', sm: 300 } }}
        options={fromArray}
        autoHighlight
        getOptionLabel={(option) => option}
        onChange={(e, newVal) => setSelectedFrom(newVal)}
        renderOption={(props, option) => (
          <Box component="li" {...props}>
            {option}
          </Box>
        )}
        renderInput={(params) => (
          <CustomTextField
            {...params}
            size = 'small'
            placeholder={t('mailTemplate.mailbox.list.filterFromP')}
            inputProps={{
              ...params.inputProps,
              autoComplete: 'new-password' // disable autocomplete and autofill
            }}
          />
        )}
      />
    </>
  )
}

export default InboxTableFilters
